module.exports = __webpack_public_path__ + "img/about_a06.fbf6f1fe.svg";